import React from 'react'

const User360sContext = React.createContext(null)

export default User360sContext
